<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="chevron-back-outline" tooltip="{{'Cancel' | translate}}"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-searchbar
      mode="ios"
      placeholder="{{'Filter Schedules' | translate}}"
      [(ngModel)]="textFilter"
      (ngModelChange)="performSearch()"
      data-tid="country-code-search"
      class="ios ion-margin-top"></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item *ngFor="let c of countries"
              (click)="selectCountry(c)"
              id="{{'country-code-' + c.code}}">
      <ion-label class="country-code">
        <b>{{c.dialCode}}</b> {{c.name | translate}}
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
